import { render, staticRenderFns } from "./ContentGeneralLedger.vue?vue&type=template&id=222c64f6"
import script from "./ContentGeneralLedger.vue?vue&type=script&lang=js"
export * from "./ContentGeneralLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports